import { spreadAndtransformDefaultValues, ToggleButton } from '@common/components/forms/controls';
import { Suspense, SuspenseButton } from '@common/components/utility';
import { CommunicationPreferenceModel } from "@common/models";
import { ClientService } from '@common/services';
import { AppointmentsStore } from '@customer/stores';
import { DateTime } from 'luxon';
import { observer } from 'mobx-react';
import React from 'react';
import { Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { PulseLoader } from 'react-spinners';
import { CommunicationPreferenceMessages } from '.';
interface ICommunicationPreferenceProps {
    store: AppointmentsStore;
    preference: CommunicationPreferenceModel;
}

export const CommunicationPreference = observer(({ store, preference }: ICommunicationPreferenceProps) => {

    const { register, handleSubmit, watch } = useForm<CommunicationPreferenceModel>({
        defaultValues: spreadAndtransformDefaultValues(preference)
    });
    watch('canSMS');
    watch('canCall');
    const save = () =>
        (data: CommunicationPreferenceModel) => {
            store.saveCommunicationPreference({ canSMS: data.canSMS, canCall: data.canCall, phoneNumber: preference.phoneNumber } as CommunicationPreferenceModel);
        }

    return (
        <>

            <div className="page-card-section-break" />
            <Row>
                <h6>Communication Preferences</h6>

                {Object.keys(CommunicationPreferenceMessages).map((key: 'canSMS' | 'canCall', index) => {
                    const toggleStateAccessor: 'canSMS' | 'canCall' = `${key}`;
                    const dateUpdatedAccessor: 'canSMSDateUpdated' | 'canCallDateUpdated' = `${key}DateUpdated`;
                    const fullNameAccessor: 'canSMSFullName' | 'canCallFullName' = `${key}FullName`;
                    const preferenceCondition = preference[toggleStateAccessor];
                    const preferenceDate = preference[dateUpdatedAccessor]
                    const whoSetPreference = preference[fullNameAccessor] ? `by ${preference[fullNameAccessor]}` : "by Client "
                    const message = CommunicationPreferenceMessages[key];
                    return <React.Fragment key={index}>
                        <div key={index} className='d-flex align-items-center'>
                            <ToggleButton className="d-inline-flex me-2" {...register(key)} aria-label={`${key}`} />
                            <div>{message}</div>
                        </div>
                        {
                            (preferenceCondition === undefined || !preferenceDate) ?
                                <><br /><br /><br></br><br></br></>
                                :
                                preferenceCondition
                                    ? <div style={{ marginLeft: '66px' }} className="petco-secondary-text mb-2">
                                        Opted in {whoSetPreference} {preferenceDate?.setZone(preference.storeTimeZone).toLocaleString(DateTime.DATETIME_SHORT)}
                                    </div>
                                    :
                                    <div style={{ marginLeft: '66px' }} className="petco-secondary-text mb-2">
                                        Opted out {whoSetPreference} {preferenceDate?.setZone(preference.storeTimeZone).toLocaleString(DateTime.DATETIME_SHORT)}
                                    </div>
                        }
                        <><br /><br /><br></br><br></br></>
                    </React.Fragment>
                })}

                <>
                    <div className='d-flex flex-row justify-content-end gap-2 align-items-end'>

                        <Suspense tag={ClientService.tags.saveCommunicationPreference} waiting={<PulseLoader />} />
                        <SuspenseButton tag={ClientService.tags.saveCommunicationPreference} hideSpinner={true} onClick={handleSubmit(save())}>Save</SuspenseButton>

                    </div>
                </>
            </Row>

            <div className="page-card-section-break" />
        </>
    );
});
